<template>
  <v-navigation-drawer
    id="app-drawer"
    app
    v-model="mostrarDrawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    persistent
    mobile-breakpoint="991"
    width="230"
    :src="barImage"
  >

    <!--<v-img
      :src="image"
      height="100%"
    > -->

      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
    
        <v-list class="fill-height">
          <v-list-item to="'/'" class="d-flex justify-center" max-height="35px">
            <!--<v-list-item-avatar
              white
            >
              <v-img
                :src="avatar"
                v-if="avatar"
                alt="Usuario"
              >
              </v-img>
            </v-list-item-avatar> -->
            <v-list-item-content>
              <v-list-item-title class="title text-center">
                App Maria Bailarina
              </v-list-item-title>
              <v-list-item-subtitle class="subtitle text-center">        
                Olá {{this.me.name}}
              </v-list-item-subtitle>        
            </v-list-item-content>
            
          </v-list-item>
          
          <v-divider/>

          <v-list-group
            v-for="item in menus"
            :key="item.text"
            v-model="item.active"
            no-action 
            :active-class="activeOpc"
            avatar
          >

            <template 
              v-slot:activator
              :active-class="activeOpc"
              avatar
              class="v-list-item">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title 
                  v-text="item.text"
                  :active-class="activeOpc"
                  avatar
                >
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="subItem in item.submenus"
              :key="subItem.text"
              :to="{ path: subItem.to}"
              :disabled="$store.state.login.loading"
              v-model="subItem.active"
              :active-class="activeOpc"
              style=""
            >
              
              <v-list-item-icon>
                <v-icon small> {{ subItem.icon}} </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title 
                  v-text="subItem.text"
                >
                </v-list-item-title>
              </v-list-item-content>

            </v-list-item>
          

          </v-list-group>
              
        </v-list>
      </v-layout>
   <!-- </v-img> -->
        
  </v-navigation-drawer>
</template>

<script>
// Utilities

import client from '@/plugins/axios'
import {
  mapMutations,
  mapState,
  mapGetters,
  mapActions,
} from 'vuex'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    logo: 'logo.png',
    menus: [],
    me: {},
  }),
  created () { 
  },
  mounted () {
    this.buscarMenu()
    this.buscarAuth()
  },
  watch: {
    /*menus(novo, antigo) {
      return novo
    },*/
    avatar(novo, antigo) {
      return novo
    }
  },
  computed: {
    ...mapState({
      barImage: state => state.app.barImage,
      color: state => state.app.color,
      barColor: state => state.app.barColor,
      token: state => state.login.token
      //menus: state => state.login.menus,
      //avatar: state => state.login.user.avatar,
    }),
    mostrarDrawer: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    activeOpc() {
      return this.color + " darken-2 rounded"
    }
  },
  methods: {
    ...mapMutations({
      setDrawer: 'app/setDrawer', 
      toggleDrawer: 'app/toggleDrawer'
    }),
    ...mapActions({
      actStartCronometro: 'login/contador',
    }),
    buscarMenu() {
      client.get('usuario/menu')
      .then(response => {
        if (response.data.status) {
          this.menus = response.data.menus
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    buscarAuth() {
      client.get('usuario/me')
      .then(response => {
        if (response.data.status) {
          this.me = response.data.autenticado
        }
      })
      .catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    opacity: 1;

    .v-list {
        background-color: black;
        opacity: 0.9;
    }

    .rounded {
      border-radius: 5px;
    }

    .v-list-group__items>.v-list-item {
        padding-left: 10px;
        margin-left: 60px !important;
        //max-height: 38px;
    }

    .v-list-item__icon:first-child {
      margin-right: 10px; 
    }

    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

     .primary--text {
      color: #ffffff !important;
    }

    .v-list-item--link:before {
     background-color: #262728;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/core/Drawer.vue